module.exports = __webpack_public_path__ + "img/feature-upload-email-hospital.ad32a868.png";